import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-influencer-card')
export class MdcInfluencerCard extends LitElement {
  @property({ type: String, attribute: 'avatar-img-src' }) avatarImgSrc = ''
  @property({ type: String, attribute: 'avatar-alt' }) avatarAlt = ''
  @property({ type: String }) name = ''
  @property({ type: String }) role = ''
  @property({ type: String }) impressions = ''
  @property({ type: String, attribute: 'media-value' }) mediaValue = ''

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-influencer-card p {
			margin: 0;
			padding: 0;
		}

		.mdc-influencer-card *,
		.mdc-influencer-card *::before,
		.mdc-influencer-card *::after {
			box-sizing: border-box;
		}

		.mdc-influencer-card {
			display: flex;
			flex-direction: column;
			max-width: 14rem;
			text-align: center;
			gap: 1rem;
		}

		.mdc-influencer-card__avatar img {
			width: 6rem;
			height: 6rem;
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
			border-radius: 100%;
		}

		.mdc-influencer-card__name {
			font-size: 1rem;
			color: var(--color-functional-gray-black, #111111);
			font-weight: 600;
			line-height: 1.3;
		}

		.mdc-influencer-card__role {
			font-size: 0.75rem;
			color: var(--color-functional-gray-400, #999999);
			font-weight: 450;
			line-height: 1.2;
			margin-top: 0.12rem;
		}

		.mdc-influencer-card__metrics {
			display: flex;
			margin-top: 1.5rem;
		}

		.mdc-influencer-card__metrics > * + * {
			margin-left: 0.5rem;
			padding-left: 0.5rem;
			border-left: 1px solid var(--color-functional-gray-200, #e5e5e5);
		}

		.mdc-influencer-card__metric {
			display: flex;
			flex-direction: column;
			flex: 1;
			gap: 0.25rem;
		}

		.mdc-influencer-card__metric-label {
			font-size: 0.6875rem;
			color: var(--color-functional-gray-400, #999999);
			font-weight: 450;
			line-height: 1.3;
		}

		.mdc-influencer-card__metric-value {
			font-size: 0.875rem;
			color: var(--color-functional-gray-black, #111111);
			font-weight: 450;
			line-height: 1.3;
		}
	`

  render() {
    return html`
			<div class="mdc-influencer-card">
				<div class="mdc-influencer-card__avatar">
					<img src=${this.avatarImgSrc} alt=${this.avatarAlt} />
				</div>
				<div class="mdc-influencer-card__content">
					<p class="mdc-influencer-card__name">${this.name}</p>
					<p class="mdc-influencer-card__role">${this.role}</p>
					<div class="mdc-influencer-card__metrics">
						<div class="mdc-influencer-card__metric">
							<p class="mdc-influencer-card__metric-value">${this.impressions}</p>
							<p class="mdc-influencer-card__metric-label">Impressions</p>
						</div>
						<div class="mdc-influencer-card__metric">
							<p class="mdc-influencer-card__metric-value">${this.mediaValue}</p>
							<p class="mdc-influencer-card__metric-label">Media Value</p>
						</div>
					</div>
				</div>
			</div>
		`
  }
}
